<div class="flex flex-col">
    <!-- Header -->
    <div class="flex flex-0 sticky top-0 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ 'workerHourBag.toCompensate' | transloco }} - {{ data.row.displayName }}</div>
        <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
            <mat-icon class="text-on-primary" [svgIcon]="'mat_outline:close'"></mat-icon>
        </button>
    </div>

    <p class="text-hint p-8">
        {{ 'workerHourBag.info' | transloco }}
    </p>

    <div class="flex">
        <div class="flex flex-col w-1/2 border-r p-8">
            <timeconverter-component class="w-full" [label]="'workerHourBag.previousBagMinutes' | transloco" [control]="previousBagMinutes" [format]="'hours'" [admitsNegative]="true"></timeconverter-component>
            <timeconverter-component class="w-full" [label]="'workerHourBag.offsetBagMinutes' | transloco" [control]="offsetBagMinutes" [format]="'hours'" [admitsNegative]="true"></timeconverter-component>
            <timeconverter-component class="w-full" [label]="'workerHourBag.currentBagMinutes' | transloco:{ overtime: minutesToString(data.row.overTime) }" [control]="currentBagMinutes" [format]="'hours'" [admitsNegative]="true"></timeconverter-component>
        </div>
        <div class="flex flex-col w-1/2 border-l p-8">
            <timeconverter-component class="w-full" [label]="'workerHourBag.compensationBagMinutes' | transloco" [control]="compensationBagMinutes" [format]="'hours'"></timeconverter-component>
            <timeconverter-component class="w-full" [label]="('workerHourBag.extraMinutes' | transloco) + (data.row.maxExtraMinutes ? ('workerHourBag.maxExtraMinutes' | transloco:{ maxExtraMinutes: minutesToString(data.row.maxExtraMinutes) }) : '')"
                (onBlur)="onExtraMinutesBlur()" [control]="extraMinutes" [format]="'hours'"></timeconverter-component>
            <timeconverter-component class="w-full" [label]="'workerHourBag.extraPlusMinutes' | transloco" [control]="extraPlusMinutes" [format]="'hours'"></timeconverter-component>
            <timeconverter-component class="w-full" [label]="('workerHourBag.complementaryMinutes' | transloco) + (data.row.maxComplementaryMinutes ? ('workerHourBag.maxComplementaryMinutes' | transloco:{ maxComplementaryMinutes: minutesToString(data.row.maxComplementaryMinutes) }) : '')"
                (onBlur)="onComplementaryMinutesBlur()" [control]="complementaryMinutes" [format]="'hours'"></timeconverter-component>
            <timeconverter-component class="w-full" [label]="'workerHourBag.complementaryPlusMinutes' | transloco" [control]="complementaryPlusMinutes" [format]="'hours'"></timeconverter-component>
        </div>
    </div>

    <!-- Footer -->
    <div class="flex justify-end sticky bottom-0 p-4 w-full bg-white dark:bg-slate-800">
        <button color="primary" mat-raised-button (click)="approve()" [disabled]="sending()">
            {{ 'accept' | transloco }}
        </button>
        <button mat-button (click)="closeDialog()" [disabled]="sending()">
            {{ 'cancel' | transloco }}
        </button>
    </div>
</div>
